import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;

  p, button {
    font-size: 0.94vw;

    ${iPadDown} {
      font-size: 3.5vw;
    }

    &.subtitle {
      text-transform: uppercase;
    }
  }
`
